import { type ICouponRepository, type IUpdateCouponUseCase, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for updating coupon data in the store.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for updating the coupon
 */
export function updateCouponUseCase(couponRepository: ICouponRepository): IUpdateCouponUseCase {
  return {
    execute: async ({ couponId, couponIndex, payload }): ReturnType<IUpdateCouponUseCase['execute']> => {
      const couponEntity = await couponRepository.getCoupon({ couponId, couponIndex });
      if (!couponEntity) {
        throw new NotFoundError(`Coupon not found: couponId: ${couponId}, couponIndex: ${couponIndex}`);
      }

      const updateEntity = couponEntity.validate(payload);
      const fieldsToUpdateCount = Object.keys(updateEntity).length;
      couponRepository.updateCoupon({ couponId, couponIndex }, (coupon) => {
        Object.assign(coupon, updateEntity);
      });

      return fieldsToUpdateCount;
    },
  };
}
